<template>
    <div>
        <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
            <el-form :inline="true" :model="formInline" class="user-search">
                <el-form-item label="所属门店：">
                    <el-select v-model="formInline.storeKeyId" placeholder="请选择门店" filterable size="small"
                        @change="inputChange">
                        <el-option v-for="item in storeList" :label="item.value" :value="item.keyId"
                            :key="item.keyId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="月份">
                    <el-date-picker v-model="dateStr" type="month" size="small" :editable="false" :clearable="false"
                        placeholder="请选择月份" format="yyyy年MM月" @change="dateChange">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="this.$checkBtnPermission('/sales/statistic', 'viewPage')" size="small"
                        type="primary" class="el-icon-search" @click="inputChange()">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="title">
                {{ title }}
            </div>
            <el-table ref="dataTable" :data="listData" v-loading="loading" border stripe :span-method="objectSpanMethod"
                :highlight-selection-row="true" empty-text="暂无数据"
                :header-cell-style="{ backgroundColor: '#b3e0ff' }" height="500px" style="border-radius: 10px;">
                <el-table-column prop="rowNumber" label="序号" align="center" width="80" isKeep="true" fixed="left" />
                <el-table-column prop="productName" label="商品名称" isKeep="true" minWidth="170" align="center"
                    fixed="left" />
                <el-table-column prop="specification" label="商品规格" isKeep="true" minWidth="120" align="center"
                    fixed="left" />
                <el-table-column prop="name" label="项目" isKeep="true" minWidth="120" align="center" fixed="left" />

                <el-table-column v-for="(item, index) in dateList" :key="index + '_' + item" prop="listQty[index]"
                    :label="item + '号'" width="80" align="center">
                    <template slot-scope="scope">
                        <!-- <span v-if="scope.$index % 7 === 0 && index == 0 ">{{ scope.row.listQty[0] }}</span>
                        <span v-else-if="scope.$index % 7 === 0 && index > 0"></span>
                        <span v-else>{{ scope.row.listQty[index] > 0 ? scope.row.listQty[index] : '--' }}</span> -->
                        <span>{{ scope.row.listQty[index] > 0 ? scope.row.listQty[index] : '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="listQty" label="合计" isKeep="true" minWidth="120" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span>{{ scope.row.listQty[scope.row.listQty.length - 1] }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </topTab>
    </div>
</template>

<script>
import {
    GetMonthStoreProductStatistics
} from "@/api/productApi.js";
import {
    GetOrgInfoListByConfig
} from "@/api/organizationalApi.js";
import { stringify } from "qs";
export default {
    data() {
        return {
            activeTab: "1",
            tabData: [
                {
                    key: "1",
                    value: "销售统计",
                },
            ],
            title: "销售统计",
            loading: false, // 显示加载
            listData: [],
            formInline: {
                storeKeyId: "",
                year: parseInt(new Date().getFullYear()),
                month: parseInt(new Date().getMonth() + 1),
            },
            storeList: [],
            dateStr: "",
            dateList: [],
            rowCount: 0,
            payCount: 0,
        };
    },
    // 注册组件
    components: {
    },
    created() {
        this.GetOrgInfoListByConfig();
        this.dateStr = new Date().getFullYear() + '-' + (new Date().getMonth() + 1);
    },
    computed: {},
    methods: {
        changePages() { },
        // 获取所属门店
        GetOrgInfoListByConfig() {
            const paramer = {
                key: 1,
            };
            GetOrgInfoListByConfig(paramer)
                .then((res) => {
                    if (res.code == 1) {
                        this.storeList = [];
                        res.data.forEach((item) => {
                            this.storeList.push({
                                keyId: item.keyId,
                                value: item.name + '【' + item.remark2 + '】',
                            });
                        });
                        this.formInline.storeKeyId = this.storeList[0].keyId;
                        this.getListData();
                    } else {
                        this.$message.error(res.msg);
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("获取门店信息失败!");
                });
        },
        // 获取列表
        getListData() {
            this.loading = true;
            //根据查询条件formInline中的年和月，往dateList中添加这个月的所有日期
            this.dateList = [];
            let date = new Date(this.formInline.year, this.formInline.month - 1, 1);
            let lastDay = new Date(this.formInline.year, this.formInline.month, 0).getDate();
            for (let i = 1; i <= lastDay; i++) {
                this.dateList.push(i);
            }
            GetMonthStoreProductStatistics(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.rowCount = 0;
                        this.payCount = 0;
                        this.loading = false;
                        this.title = res.data.title;
                        this.listData = [];
                        var listShowList = [];
                        var rowNumber = 1;
                        var rowCount = 0;
                        res.data.items.forEach((item) => {
                            var infoEarly = {
                                rowNumber: item.rowNumber,
                                productName: item.productName,
                                specification: item.specification,
                                name: '月初结余',
                                listQty: [item.earlyMonthQuantity],
                            };
                            listShowList.push(infoEarly);
                            var infoInput = {
                                rowNumber: item.rowNumber,
                                productName: item.productName,
                                specification: item.specification,
                                name: '入库',
                                listQty: item.inputQty,
                            };
                            listShowList.push(infoInput);
                            var infosales = {
                                rowNumber: item.rowNumber,
                                productName: item.productName,
                                specification: item.specification,
                                name: '销售',
                                listQty: item.salesQty,
                            };
                            listShowList.push(infosales);
                            var infoGift = {
                                rowNumber: item.rowNumber,
                                productName: item.productName,
                                specification: item.specification,
                                name: '赠送',
                                listQty: item.giftQty,
                            };
                            listShowList.push(infoGift);
                            var infoVip = {
                                rowNumber: item.rowNumber,
                                productName: item.productName,
                                specification: item.specification,
                                name: '卡销',
                                listQty: item.vipQty,
                            };
                            listShowList.push(infoVip);
                            var infoRemaining = {
                                rowNumber: item.rowNumber,
                                productName: item.productName,
                                specification: item.specification,
                                name: '结余',
                                listQty: item.remainingQty,
                            };
                            listShowList.push(infoRemaining);
                            var infoMoney = {
                                rowNumber: item.rowNumber,
                                productName: item.productName,
                                specification: item.specification,
                                name: '销售金额(元)',
                                listQty: item.salesMoney,
                            };
                            listShowList.push(infoMoney);

                            rowCount += 7;
                            rowNumber++;
                        });
                        this.rowCount = rowCount;
                        this.payCount = res.data.payment.length;
                        res.data.payment.forEach((item) => {
                            listShowList.push({
                                rowNumber: rowNumber++,
                                productName: '收款方式',
                                specification: item.paymentTypeName,
                                name: '',
                                listQty: item.listMoney,
                            });
                        });
                        listShowList.push({
                            rowNumber: rowNumber++,
                            productName: '总收款额',
                            specification: '',
                            name: '',
                            listQty: res.data.totalSalesMoney,
                        });
                        this.listData = listShowList;
                        //重新计算表格的展示样式，解决出现乱行的问题
                        // 在数据更新后调用
                        this.$nextTick(() => {
                            this.$refs.dataTable.doLayout()
                        });
                        console.log(this.rowCount);
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                });
        },
        inputChange(val) {
            this.search();
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.getListData();
        },
        // 月份选择事件
        dateChange() {
            this.formInline.year = this.dateStr.getFullYear();
            this.formInline.month = this.dateStr.getMonth() + 1;
            this.getListData();
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (rowIndex < this.rowCount) {
                if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
                    if (rowIndex % 7 === 0) {
                        return {
                            rowspan: 7,
                            colspan: 1
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            }
            else if (rowIndex == this.rowCount) {
                if (columnIndex == 1) {
                    return {
                        rowspan: this.payCount,
                        colspan: 1
                    };
                }
                else if (columnIndex == 2) {
                    return {
                        rowspan: 1,
                        colspan: 2
                    };
                }
                else if (columnIndex == 3) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
            else if (rowIndex > this.rowCount && rowIndex < this.rowCount + this.payCount) {
                if (columnIndex === 1) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
                else if (columnIndex == 2) {
                    return {
                        rowspan: 1,
                        colspan: 2
                    };
                }
                else if (columnIndex == 3) {
                    return {
                        rowspan: 0,
                        colspan: 0
                    };
                }
            }
            else if (rowIndex = this.rowCount + this.payCount) {
                if (columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
                    if (columnIndex === 1) {
                        return {
                            rowspan: 1,
                            colspan: 3
                        };
                    } else {
                        return {
                            rowspan: 0,
                            colspan: 0
                        };
                    }
                }
            }
        }
    },
};
</script>

<style scoped>
.title {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: center;
}
</style>